import { Icon } from './Icon';

const CHANGE_NOW_CONTACT_URL = 'https://changenow.com/contact';

export function TransactionSupportCard({
  eyebrow,
  title,
  description,
  cta,
}: {
  eyebrow: string;
  title: string;
  description: string;
  cta: string;
}) {
  return (
    <aside className="transaction-support" aria-labelledby="transaction-support-title">
      <div className="transaction-support-logo">
        <img src="/changenow-logo.png" alt="ChangeNOW logo" width={96} height={96} />
      </div>
      <div className="transaction-support-content">
        <span className="eyebrow">{eyebrow}</span>
        <h2 id="transaction-support-title">{title}</h2>
        <p>{description}</p>
        <a
          className="btn btn-primary transaction-support-link"
          href={CHANGE_NOW_CONTACT_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          {cta}
          <Icon name="arrow-right" width={16} height={16} />
        </a>
      </div>
    </aside>
  );
}
